import { OverlayAnnotations } from '@readcloud/common';
import React from 'react';
import { useDebounce } from 'use-debounce/lib';
import { DrawCanvas } from '../DrawCanvas';
import { AnnotationRendererProps } from '../types';
const voidFn = () => {};
export const PathAnnotationViewer = React.memo(function PathAnnotationViewer(
  props: AnnotationRendererProps<
    OverlayAnnotations.PathAnnotation['data'],
    OverlayAnnotations.PathAnnotation['type']
  >
) {
  const [debouncedHeight] = useDebounce(props.height, 200);
  const [debouncedWidth] = useDebounce(props.width, 200);
  return (
    <div className="rc-overflow-hidden rc-h-full rc-w-full">
      <DrawCanvas
        scale={props.scale}
        viewOnly
        stroke={props.data.stroke}
        strokeWidth={props.data.strokeWidth}
        onPathsChange={voidFn}
        paths={props.data.paths}
        height={debouncedHeight}
        width={debouncedWidth}
      />
    </div>
  );
});
